var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("box", { attrs: { hideable: true } }, [
    _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
      _c("i", { staticClass: "fas fa-sign-in-alt" }),
      _vm._v(" Input\n    ")
    ]),
    _vm._v(" "),
    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
      _c("div", { staticClass: "row mb-2" }, [
        _c("div", { staticClass: "col-4" }, [
          _c("label", { attrs: { for: "schemeId" } }, [_vm._v("Scheme")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("div", { staticClass: "input-group-text" }, [
                  _c("i", { staticClass: "fas fa-cubes" })
                ])
              ]),
              _vm._v(" "),
              _vm.schemes
                ? _c("dropdown", {
                    attrs: {
                      name: "schemeId",
                      textField: "value",
                      valueField: "key",
                      placeholder: "--select scheme--",
                      datasource: _vm.schemes
                    },
                    model: {
                      value: _vm.newSchemeId,
                      callback: function($$v) {
                        _vm.newSchemeId = $$v
                      },
                      expression: "newSchemeId"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-auto button-container" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary mt-auto",
              attrs: { disabled: !_vm.schemeId },
              on: { click: _vm.openScheme }
            },
            [
              _c("i", { staticClass: "fas fa-external-link-alt" }),
              _vm._v(" Open scheme\n                ")
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary mt-auto",
              attrs: { disabled: !_vm.schemeId },
              on: { click: _vm.validateScheme }
            },
            [
              _c("i", { staticClass: "fas fa-check-circle" }),
              _vm._v(
                " " +
                  _vm._s(_vm.resource("Operator_Test_ValidateScheme_Button")) +
                  "\n                "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-2" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("json-editor", {
              on: {
                error: function($event) {
                  _vm.validJson = !$event
                }
              },
              model: {
                value: _vm.json,
                callback: function($$v) {
                  _vm.json = $$v
                },
                expression: "json"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-2" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { disabled: !_vm.testIsValid },
              on: {
                click: function($event) {
                  return _vm.runTest()
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-vial" }),
              _vm._v(" Run test\n                ")
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }